<div class="wil-dashboard wil-content" id="wilcity-dashboard">
    <section id="wilcity-dashboard-inner" class="wil-section wil-dashboard-inner bg-color-gray-2 pd-0">
        <div class="dashboard-content_module__zpEtP clearfix">

            <app-dashboard-sidebar></app-dashboard-sidebar>

            <div class="dashboard__content">
                <router-outlet></router-outlet>
            </div>

        </div>
    </section>
</div>